export function getDraftProviderPrefix(uuid) {
  return `email-${uuid}`
}
